/* eslint-disable indent */
import React from "react";
import styles from "../stylesER.module.scss";

export const HardwareFlexModal = ({
  isOpen,
  monthIndex,
  selectedYear,
  meses,
  puedeEditar,
  formatCurrency,
  // Summary values
  compraHardware,
  instalacion,
  materiales,
  otrosCostos,
  // Form state
  nuevoCostoNegocioId,
  setNuevoCostoNegocioId,
  nuevoCostoMonto,
  setNuevoCostoMonto,
  nuevoCostoTipo,
  setNuevoCostoTipo,
  // Data
  negociosCarteleria,
  getNombreNegocio,
  costosDelMes,
  // Actions
  onAdd,
  onDelete,
  onClose,
}) => {
  if (!isOpen || monthIndex === null) return null;

  const tipoLabels = {
    compra_hardware: "Compra hardware",
    instalacion: "Instalación (mano de obra)",
    materiales: "Materiales",
    otros_costos: "Otros costos",
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={styles.modalContent}
        style={{ maxWidth: "900px", width: "95%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <h3>
          Costos Hardware - {meses[monthIndex]} {selectedYear}
        </h3>

        <div style={{ marginBottom: "16px", fontWeight: "600", fontSize: "1.1rem" }}>
          Compra hardware: {formatCurrency(compraHardware || 0)} | Instalación: {formatCurrency(instalacion || 0)} |
          Materiales: {formatCurrency(materiales || 0)} | Otros costos: {formatCurrency(otrosCostos || 0)}
        </div>

        {/* Formulario agregar */}
        <div style={{ background: "#f9f9f9", padding: "16px", borderRadius: "8px", marginBottom: "20px 0" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 150px 140px 140px",
              gap: "12px",
              alignItems: "end",
            }}
          >
            {/* Proyecto */}
            <div>
              <label style={{ fontSize: "0.9rem", display: "block", marginBottom: "4px" }}>Proyecto (opcional)</label>
              <select
                value={nuevoCostoNegocioId || ""}
                onChange={(e) => setNuevoCostoNegocioId(e.target.value ? Number(e.target.value) : null)}
                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
              >
                <option value="">— Costo libre —</option>
                {negociosCarteleria
                  .filter((n) => !n.eliminada)
                  .sort((a, b) => a.id - b.id)
                  .map((n) => (
                    <option key={n.id} value={n.id}>
                      {getNombreNegocio(n)}
                    </option>
                  ))}
              </select>
            </div>

            <div>
              <label style={{ fontSize: "0.9rem", display: "block", marginBottom: "4px" }}>Monto</label>
              <input
                type="number"
                value={nuevoCostoMonto}
                onChange={(e) => setNuevoCostoMonto(e.target.value)}
                placeholder="0"
                min="1"
                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
              />
            </div>

            <div>
              <label style={{ fontSize: "0.9rem", display: "block", marginBottom: "4px" }}>Tipo</label>
              <select
                value={nuevoCostoTipo}
                onChange={(e) => setNuevoCostoTipo(e.target.value)}
                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #ccc" }}
              >
                <option value="compra_hardware">Hardware</option>
                <option value="instalacion">Instalación</option>
                <option value="materiales">Materiales</option>
                <option value="otros_costos">Otros costos</option>
              </select>
            </div>

            {puedeEditar ? (
              <button
                onClick={onAdd}
                style={{
                  padding: "10px 16px",
                  background: "#1976d2",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                + Agregar
              </button>
            ) : (
              <button
                disabled
                style={{
                  padding: "10px 16px",
                  background: "#ccc",
                  color: "#666",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "not-allowed",
                }}
              >
                Sin permiso
              </button>
            )}
          </div>
        </div>

        {/* Tabla de costos existentes */}
        <div style={{ overflowX: "auto" }}>
          <table className={styles.modalTable}>
            <thead>
              <tr>
                <th>Proyecto</th>
                <th>Tipo</th>
                <th style={{ textAlign: "right" }}>Monto</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {costosDelMes.map((c) => {
                const negocio = negociosCarteleria.find((n) => n.id === c.negocio_id);
                const nombre = negocio ? `${c.negocio_id} - ${getNombreNegocio(negocio)}` : "Costo libre";
                return (
                  <tr key={c.id}>
                    <td>{nombre}</td>
                    <td>{tipoLabels[c.tipo] || c.tipo}</td>
                    <td style={{ textAlign: "right" }}>{formatCurrency(c.monto)}</td>
                    <td>
                      {puedeEditar ? (
                        <button
                          onClick={() => onDelete(c.id)}
                          style={{
                            background: "#d32f2f",
                            color: "white",
                            border: "none",
                            padding: "4px 8px",
                            borderRadius: "4px",
                            fontSize: "12px",
                          }}
                        >
                          Eliminar
                        </button>
                      ) : (
                        <span style={{ color: "#999", fontSize: "12px" }}>—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className={styles.modalActions}>
          <button className={styles.btnClose} onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};
